<!-- Общая история переходов: компактный список с полными комментариями и раскрытием старых событий. -->
<template>
  <BaseFormSection title="История статусов" icon="time" :count="entries.length" :summary="summary"
    :columns="1" collapsible :initially-expanded="false">
    <div v-if="entries.length">
      <ol class="record-list-history">
        <li v-for="entry in visibleEntries" :key="entry.id" class="record-list-history__entry"
          :style="{ '--history-color': entry.from_status ? entry.from.color : entry.to.color }">
          <div class="record-list-history__content">
            <div class="record-list-history__statuses">
              <span v-if="entry.from_status" class="record-list-history__previous">
                <span class="record-list-history__dot" :style="{ backgroundColor: entry.from.color }" aria-hidden="true" />
                {{ entry.from.label }}
              </span>
              <span v-if="entry.from_status" class="record-list-history__arrow" aria-label="переход в">→</span>
              <span class="record-list-history__current">
                <span class="record-list-history__dot" :style="{ backgroundColor: entry.to.color }" aria-hidden="true" />
                {{ entry.to.label }}
              </span>
            </div>
            <div class="record-list-history__meta">
              <time v-if="entry.time" :datetime="entry.time">{{ formatDate(entry.time) }}</time>
              <span v-if="entry.time" aria-hidden="true">·</span>
              <span>{{ authorName(entry.created_by) }}</span>
            </div>
            <p v-if="entry.comment" class="record-list-history__comment">{{ entry.comment }}</p>
          </div>
        </li>
      </ol>
      <button v-if="entries.length > previewCount" type="button" class="record-list-history__toggle"
        :aria-expanded="showAll" @click="showAll = !showAll">
        {{ showAll ? 'Свернуть до последних 5' : `Показать все ${entries.length} событий` }}
      </button>
    </div>
    <span v-else>История изменений статуса отсутствует</span>
  </BaseFormSection>
</template>
<script>
import { buildStatusHistory } from "@/utils/statusHistoryUtils";
import { formatDateAndTimeLocal } from "@/utils/dateUtils";

export default {
  name: "RecordListStatusHistory",
  props: {
    transitions: { type: Array, default: () => [] },
    statuses: { type: Array, default: () => [] },
  },
  data() {
    return { showAll: false, previewCount: 5 };
  },
  computed: {
    entries() { return buildStatusHistory(this.transitions, this.statuses); },
    visibleEntries() { return this.showAll ? this.entries : this.entries.slice(0, this.previewCount); },
    summary() {
      const latest = this.entries[0];
      return latest ? `${latest.to.label} · ${this.formatDate(latest.time)}` : "История изменений статуса отсутствует";
    },
  },
  methods: {
    formatDate: formatDateAndTimeLocal,
    authorName(user) {
      return user?.initials || user?.full_name || user?.name || "Автор не указан";
    },
  },
};
</script>
<style scoped>
.record-list-history {
  list-style: none;
  margin: 0;
  padding: 0 0 0 4px;
}
.record-list-history__entry {
  position: relative;
  border-left: 1px solid var(--history-color, #dce3ea);
  padding: 0 0 12px 16px;
}
.record-list-history__entry::before {
  content: "";
  position: absolute;
  left: -3px;
  top: 19px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--history-color, #94a3b8);
}
.record-list-history__content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f6f8fa;
}
.record-list-history__entry:last-child { padding-bottom: 0; }
.record-list-history__statuses {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  line-height: 1.5;
}
.record-list-history__previous { color: #64748b; }
.record-list-history__previous,
.record-list-history__current {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.record-list-history__dot {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
}
.record-list-history__arrow { color: #94a3b8; }
.record-list-history__current { color: #334155; font-weight: 500; }
.record-list-history__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.record-list-history .record-list-history__comment {
  margin: 3px 0 0;
  color: #475569;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.record-list-history__toggle {
  margin-top: 14px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
}
.record-list-history__toggle:hover { color: #334155; }
.record-list-history__toggle:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 4px;
}
</style>
